import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { STEP_ORDER, type ProyectoWizardStepKey } from '@/features/crear-proyecto';
import { ProyectoContinuarPage } from '@/pages/proyecto-continuar';

/**
 * Search param opcional `paso`: paso del wizard en el que se debe abrir el
 * borrador. Lo usa el alta (`/proyectos/nuevo`) al redirigir aquí tras crear la
 * cabecera, para caer directo en el paso 2 sin volver a pedir los datos
 * generales. Si falta o es inválido, el wizard abre en el paso 1.
 */
export interface ProyectoContinuarSearch {
  paso?: ProyectoWizardStepKey;
}

export const Route = createFileRoute('/_private/proyectos/$id/continuar')({
  beforeLoad: () => exigirAcceso('proyectos', 'create'),
  validateSearch: (search: Record<string, unknown>): ProyectoContinuarSearch => {
    const paso = search.paso;
    return typeof paso === 'string' && (STEP_ORDER as ReadonlyArray<string>).includes(paso)
      ? { paso: paso as ProyectoWizardStepKey }
      : {};
  },
  component: ProyectoContinuarPage,
});
